import { RequestData } from 'interfaces/request.interface';
import { IResponsesDB } from 'interfaces/response.interface';
import { Nullable } from 'utils/Nullable';
import { RequestDetailsModalFocus } from '../RequestDetails/RequestDetails.props';
import { QueryState } from '../../../common/enums';

export enum DashboardMainModal {
  UNDEFINED = 0,
  ACCEPT = 1,
  DECLINE = 2,
  ARCHIVED = 3,
  REMIND = 4,
  PROVIDED_RESOURCES = 5,
  OFFERS = 6,
}

export interface DashboardModalFocus {
  modal: DashboardMainModal;
  response: IResponsesDB;
  request: RequestData;
  responses: IResponsesDB[];
  isRequestProcessing?: boolean;
}

interface DashboardMainPublicProps {
  /** public props */
  navigateTo: (path?: string) => void;
  requests: Nullable<RequestData[]> | undefined;
  responses: Nullable<IResponsesDB[]> | undefined;
  page: number;
  pagesTotal: number;
  lastPage: number;
  loading: boolean;
  isRequestProcessing: boolean;
  serviceActionRequest: QueryState;
  modalFocus: Partial<DashboardModalFocus>;
  childModalFocus: Partial<DashboardModalFocus>;
  handlePageChange: (num: number) => void;
  handleModalFocus: (modalFocus: Partial<DashboardModalFocus>) => void;
  handleChildModalFocus: (childModalFocus: Partial<DashboardModalFocus>) => void;
  manageIncidentModal: boolean;
  handleManageIncidentModal: (show: boolean) => void;
  offersModal: boolean;
  handleOffersModal: (show: boolean) => void;
  onEditRequest: (request: RequestData) => void;
  onChangeShift: (request: RequestData) => void;
  resetModalFocus: () => void;
}

export type DashboardMainProps = DashboardMainPublicProps;
